import { useEffect, useRef } from 'react';

/** Page-level heading + sub shown above each bulk-send wizard step's own content
 *  (Figma: 24px heading, 16px muted sub) — one shared slot instead of four copies.
 *  Focuses its own heading whenever `heading` changes, so a screen-reader user
 *  who advances the wizard lands somewhere that announces the new step. */
export function WizardStepHeader({ heading, sub }: { heading: string; sub: string }) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, [heading]);

  return (
    <div>
      <h2 ref={headingRef} tabIndex={-1} className="text-heading-h5 text-foreground outline-none">
        {heading}
      </h2>
      <p className="mt-1 text-body-md-regular text-muted-foreground">{sub}</p>
    </div>
  );
}
